<template>
  <Page class="not-activated">
    <div class="message-container">
      <div class="info-message">Your company elected not to add PipelinePrequal. If you would like to add it to your account, please contact <a href="mailto:sales@pipelinesuite.com">sales@pipelinesuite.com</a> or call <a href="tel:949-222-0400">949-222-0400</a></div>
    </div>
  </Page>
</template>

<script setup>

import Page from "@/components/Page.vue";

</script>

<style lang="scss" scoped>

.not-activated {
  .message-container {

    .info-message {
      display: block;
      margin-left: 2em;
      margin-right: 2em;
    }
  }
}

</style>
